/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import { GiHamburgerMenu } from "react-icons/gi";
import { IconContext } from "react-icons";
import ticketSingle from "../../assets/png/ticket_single.png"

const StadeoNavbar = () => {
  const [hamburgerToggled, setHamburgerToggled] = useState(false)

  const handleToggleHamburger = () => {
    const ham_state = !hamburgerToggled
    setHamburgerToggled(ham_state)
  }


  return (
    <nav className="bg-white shadow-lg w-full h-[71px] md:h-[80px]">
      <div className="flex lg:items-center justify-between lg:flex-wrap cursor-pointer">
        <div className="pl-[12px] pt-[15px] md:pt-[18px]">
            {/* <svg className="h-8 w-8 mr-2" width="54" height="54" viewBox="0 0 54 54" xmlns="http://www.w3.org/2000/svg"><path d="M13.5 22.1c1.8-7.2 6.3-10.8 13.5-10.8 10.8 0 12.15 8.1 17.55 9.45 3.6.9 6.75-.45 9.45-4.05-1.8 7.2-6.3 10.8-13.5 10.8-10.8 0-12.15-8.1-17.55-9.45-3.6-.9-6.75.45-9.45 4.05zM0 38.3c1.8-7.2 6.3-10.8 13.5-10.8 10.8 0 12.15 8.1 17.55 9.45 3.6.9 6.75-.45 9.45-4.05-1.8 7.2-6.3 10.8-13.5 10.8-10.8 0-12.15-8.1-17.55-9.45-3.6-.9-6.75.45-9.45 4.05z"/></svg>
            <span className="font-semibold text-xl tracking-tight">Jelajah Holiday</span> */}
            <h1 className="font-monumentextended text-[30px] font-bold tracking-[3px]">STADEO</h1>
        </div>
        <div className="md:hidden pt-[23px] mr-4">
          <IconContext.Provider value={{ size: "1.5em" }}>
            <div>
              <GiHamburgerMenu color='#09B251' onClick={() => handleToggleHamburger()}/>
            </div>
          </IconContext.Provider>
        </div>
        <div className="hidden md:block h-full flex w-auto pr-[20px]">
          <div className="flex">
            <p className="pt-[30px] text-[12px] text-stadeo-grayed-4 font-montserrat font-semibold tracking-[1px] hover:text-black md:px-[43px]"
              onClick={() => { window.location.href = 'https://www.stadeo.com/live-now' }}>LIVE NOW</p>
            <p className="pt-[30px] text-[12px] text-stadeo-grayed-4 font-montserrat font-semibold tracking-[1px] hover:text-black md:px-[48px]"
              onClick={() => { window.location.href = 'https://www.stadeo.com/become-a-creator-2' }}>BECOME A CREATOR</p>
            <div className='flex space-x-[19px]'>
              <div className='mt-[16px] bg-stadeo-bold-green rounded-[6px] hover:bg-black w-auto'
                onClick={() => {  window.location.reload() }}>
                <p className='text-[12px] text-white font-montserrat font-semibold tracking-[1px] py-[13px] px-[31px]'>BUY TICKETS</p>
              </div>
              <div className='mt-[16px] bg-stadeo-bold-green rounded-[6px] hover:bg-black w-auto'
                onClick={() => { window.location.href = 'mailto:support@stadeo.com' }}>
                <p className='text-[12px] text-white font-montserrat font-semibold tracking-[1px] py-[13px] px-[31px]'>CONTACT</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {
        hamburgerToggled ? (
          <div className="bg-white  z-10 right-0 w-2/3 pt-[10px] absolute">
            <div className="m-3 h-full">
              <p className="text-[12px] text-stadeo-grayed font-montserrat font-semibold tracking-[1px]"
                onClick={() => { window.location.href = 'https://www.stadeo.com/live-now' }}>LIVE NOW</p>
            </div>
            <div className="m-3 h-full">
              <p className="text-[12px] text-stadeo-grayed font-montserrat font-semibold tracking-[1px]"
                onClick={() => { window.location.href = 'https://www.stadeo.com/become-a-creator-2' }}>BECOME A CREATOR</p>
            </div>
            <div className='m-3 h-full'>
              <div className='bg-stadeo-bold-green rounded-[6px] hover:bg-black w-auto text-center'
                onClick={() => { window.location.reload() }}>
                <p className='text-[12px] text-white font-montserrat font-semibold tracking-[1px] py-[12px] px-[30px]'>BUY TICKETS</p>
              </div>
            </div>
            <div className='m-3 h-full'>
              <div className='bg-stadeo-bold-green rounded-[6px] hover:bg-black w-auto text-center'
                onClick={() => { window.location.href = 'mailto:support@stadeo.com' }}>
                <p className='text-[12px] text-white font-montserrat font-semibold tracking-[1px] py-[12px] px-[30px]'>CONTACT</p>
              </div>
            </div>
          </div>
        ) : null
      }
    </nav>
  )
}

export default StadeoNavbar;